import Vue from "vue";

import Message from "./message";
import User from "./user";

Vue.use(Message);
Vue.use(User);
